<template lang="pug">
.guide(v-if="show", @click="nextStep")
  .guide-step-1(v-if="step === 1")
    img(src="~assets/footprint/task-1.png")
    .guide-step-1-tip 在展厅体验展点<br />即可获得主线贴纸
  .guide-step-2(v-if="step === 2")
    img(src="~assets/footprint/task-8-w.png")
    .guide-step-2-tip 点击虚线做任务<br />完成即可获得支线贴纸
  .guide-step-3(v-if="step === 3 && showAsk")
    img(src="~assets/footprint/icon-ask.png")
    .guide-step-3-tip 此处查看玩法
  .guide-step-3-box(v-if="step === 3")
    .guide-intro-close(@click="close")
    .guide-intro-title 获取盲盒购买码看这里
    .guide-intro-desc 核身并体验至少三个互动项目后即可在右上角获得指定盲盒贴纸，点开后前往微笑商店输入您的购买资格码即可支付购买。
    .guide-intro-step
      dl
        dt
          span 体验
          b 3
          span 个展项
        dd 召唤盲盒购买码      
    .guide-intro-tip p.s.刷脸/扫码体验，收集主线贴纸解锁不同惊喜<br/>虚线框为支线，点击完成相应任务，即可获得贴纸
    .guide-intro-btn
      span(@click="close") 确定
</template>
<script>
export default {
  name: 'Guide',
  props: {
    step: Number,
  },
  data() {
    return {
      showAsk: true,
    }
  },
  computed: {
    show() {
      return [1, 2, 3].includes(this.step);
    }
  },
  methods: {
    nextStep() {
      if (this.step === 3) {
        return;
      }
      this.$emit('onSetGuideStep', this.step + 1);
    },
    close() {
      this.$emit('onSetGuideStep', this.step + 1);
      this.showAsk = false;
    }
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common"
@import "src/styles/footprint"
.guide
  +full; z-index: 9999; position: fixed; background: rgba(0, 0, 0, 0.55)
  +flex-center
  img
    +image
  &-step-1
    position: absolute; width: pxRes(69); left: pxRes(243); top: pxRes(123)
    &-tip
      position: absolute; width: pxRes(180); right: pxRes(78); top: pxRes(334); color: #FFFFFF
      font-size: pxRes(12); line-height: pxRes(17); text-align: right; padding: pxRes(6) pxRes(34) 0 0
      background: url("~assets/footprint/img-arrow.png") right top no-repeat
      background-size: pxRes(27.5)
  &-step-2
    position: absolute; width: pxRes(89.5); left: pxRes(15); top: pxRes(362)
    &-tip
      position: absolute; width: pxRes(180); left: pxRes(25); top: pxRes(68); color: #FFFFFF
      font-size: pxRes(12); line-height: pxRes(17); padding: pxRes(57) 0 0 pxRes(7)
      background: url("~assets/footprint/img-hand.png") left top no-repeat
      background-size: pxRes(50)
  &-step-3
    position: absolute; width: pxRes(27); left: pxRes(378); top: pxRes(123)
    &-tip
      position: absolute; width: pxRes(180); right: pxRes(22); top: pxRes(30); color: #FFFFFF
      font-size: pxRes(12); line-height: pxRes(17); text-align: right; padding: 0 pxRes(34) 0 0
      background: url("~assets/footprint/img-arrow.png") right top no-repeat
      background-size: pxRes(27.5)
  &-step-3-box
    margin-top: pxRes(40)
    width: pxRes(353); background: #FFFFFF; border-radius: pxRes(9); position: relative
    color: #666666; font-size: pxRes(12); line-height: pxRes(17); text-align: center
    .guide-intro-close
      position: absolute; width: pxRes(20.5); height: pxRes(20.5); right: pxRes(13); top: pxRes(15)
      background: url("~assets/footprint/icon-close.png") center no-repeat
      background-size: pxRes(20.5)
    .guide-intro-title
      font-size: pxRes(30); line-height: pxRes(42); padding: pxRes(30) 0 0 0; font-weight: 500; color: #333333
    .guide-intro-desc
      font-size: pxRes(14); line-height: pxRes(20); padding: pxRes(8) pxRes(30) 0 pxRes(30);; color: #1677FF
    .guide-intro-step
      padding: pxRes(20) pxRes(20) 0 ; display: flex
      dl
        flex: 1; margin: 0
      dt b
        font-family: 'DIN Alternate';
        font-weight: bold; font-size: pxRes(50); line-height: pxRes(58); color: #0066FF;
      dt span
        font-weight: 500; font-size: pxRes(16); line-height: pxRes(23); color: #333333;
      dd
        color: #666666; font-size: pxRes(12); line-height: pxRes(17); margin: 0
      dl.guide-intro-step-mid
        position: relative
        &:before, &:after
          content: ''; position: absolute; width: pxRes(19); height: pxRes(5); top: pxRes(33)
          background: url("~assets/footprint/img-point.png") center no-repeat
          background-size: pxRes(19)
        &:before
          left: pxRes(-9.5)
        &:after
          right: pxRes(-9.5)      
    .guide-intro-tip
      margin: pxRes(27) pxRes(30) 0; padding: pxRes(24) 0 0
      border-top: 1px solid #DDDDDD;
      color: #999999; font-size: pxRes(10); line-height: pxRes(14)
    .guide-intro-btn
      padding: pxRes(19) 0 pxRes(38)
      span
        +inline-block
        border: 1px solid #1677FF; border-radius: pxRes(19);
        font-size: pxRes(16); line-height: pxRes(23); padding: pxRes(4.5) pxRes(23); color: #1677FF
</style>
